// Webpack Imports
import * as bootstrap from 'bootstrap';


(function () {
    'use strict';

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
        el.addEventListener('submit', function (e) {
            var search = el.querySelector('input');
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });


    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });
})();

const nav = document.getElementById('header');
const headerLogo = document.getElementById('header-logo')
window.onscroll = function () {
    if (document.body.scrollTop >= 100 || document.documentElement.scrollTop >= 100) {
        nav.classList.add("bg-white");
        nav.classList.add("shadow");
        nav.classList.remove("bg-transparent");
        headerLogo.classList.add("logo-scrolled")
    } else {
        nav.classList.add("bg-transparent");
        nav.classList.remove("bg-white");
        nav.classList.remove("shadow");
        headerLogo.classList.remove("logo-scrolled")
    }
};

const btnScrollToTop = document.getElementById("btnScrollToTop");

// scroll to top of page when button clicked
btnScrollToTop.addEventListener("click", e => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
});

// toggle 'scroll to top' based on scroll position
window.addEventListener('scroll', e => {
    btnScrollToTop.style.display = window.scrollY > 20 ? "block" : "none";
});
import PhotoSwipeLightbox from './dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from './dist/photoswipe.esm.js';

const elementExists = document.getElementById("gallery");
if (elementExists) {
    const lightbox = new PhotoSwipeLightbox({
        gallery: '#gallery',
        children: 'a',
        pswpModule: PhotoSwipe
    });
    lightbox.init();
}
